import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';
import Button from 'shared/button';

import type { Task } from 'bundles/apex/tasks/types';

interface Props {
  task: Task;
  onClick?: () => void;
}

export default function AttachmentIcon({ task, onClick }: Props) {
  if (task.attachments.length > 0) {
    return <div className="clickable" onClick={onClick}>{`${task.attachments.length} Attached`}</div>;
  } else if (task.attachmentExceptionReason) {
    return (
      <Tooltip content={task.attachmentExceptionReason}>
        <span>0 Attached</span>
      </Tooltip>
    );
  } else {
    return (
      <Button.Primary className="clickable" outlined onClick={onClick}>
        <FontAwesomeIcon icon={faPaperclip} />
      </Button.Primary>
    );
  }
}
